__turbopack_context__.v({
  "parallax": "VT35Wa_parallax",
  "root": "VT35Wa_root",
  "wave1": "VT35Wa_wave1",
  "wave2": "VT35Wa_wave2",
  "wave3": "VT35Wa_wave3",
  "wave4": "VT35Wa_wave4",
  "waves": "VT35Wa_waves",
  "waving": "VT35Wa_waving",
});
